import { CaptionText, Link } from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { CALL_US_INFO, FPTI_DATA } from '../../common/propTypes';
import {
  getCurrentLocationUrl,
  getHTMLElement,
  isMobileLayout,
  isMobileWebCallUsLinkEnabled,
} from '../../helpers/twHelper';
import { generateLinkData, trackActivityEvent } from '../../helpers/analytics/fptiHelper';
import GoogleStructuredData from '../../../js/contactUs/components/common/GoogleStructuredData';

function Dialing(props) {
  const { onWebPinClick, callUsInfo, FPTIData } = props;
  const phoneNumber = callUsInfo.phoneNumbers[0];
  const hourOfService = getHTMLElement({ message: callUsInfo.customerHour.hoursOfService, useHTML: true });

  useEffect(() => {
    if (phoneNumber) {
      trackActivityEvent({
        ...FPTIData.callUsPhoneNumber,
        link: generateLinkData(FPTIData.callUsPhoneNumber.link, { phoneNo: phoneNumber }),
      });
    }
  }, [phoneNumber]);

  const renderPhoneNumber = () => {
    return (
      <Link
        href={`tel:${phoneNumber}`}
        aria-label={phoneNumber}
        size="lg"
        className="sh_callUs_phNo_link"
        data-testid="sh-callUs-phNo_link"
        onClick={(e) => onWebPinClick(e, phoneNumber)}
      >
        <a className="sh_callUs_phNo" data-testid="sh-callUs-phNo">
          {isMobileLayout() && isMobileWebCallUsLinkEnabled() ? (
            <Message id="smarthelp.app.callUs.Webpin.mobile.tapToCall" />
          ) : (
            phoneNumber
          )}
        </a>
      </Link>
    );
  };

  const renderInstructionalInfo = () => {
    return (
      <div className="sh_callUs_instructions_info">
        <div className="sh_callUs_instructions_info_image_container">
          <img
            src="https://www.paypalobjects.com/Smarthelpnodeweb/call-mobile-person-avatar.png"
            alt=""
            className="sh_callUs_instructions_info_image"
            data-testid="sh-callUs-instructions-info-image"
          />
        </div>
        <div className="sh_callUs_instructions_info_contents">
          {renderPhoneNumber(phoneNumber)}
          <GoogleStructuredData
            type="Organization"
            data={{ url: getCurrentLocationUrl(), telephone: phoneNumber, department: 'Customer Service' }}
          />
          <CaptionText size="md" className="sh_callUs_hours_of_service" data-testid="sh-callUs-hours-of-service">
            {hourOfService}
          </CaptionText>
          <CaptionText className="sh_callUs_accessibility_message" data-testid="sh-callUs-accessibility-message">
            <Message id="smarthelp.app.callUs.Accessiability.message" />
          </CaptionText>
        </div>
      </div>
    );
  };

  const renderSpecialInstructions = () => {
    const specialCallUsInstructions = getHTMLElement({ message: callUsInfo.specialInstruction, useHTML: true });
    return (
      <div className="sh_callUs_dialing_card_special">
        <CaptionText size="md" className="sh_callUS_specialInstructions" data-testid="sh-callUS-specialInstructions">
          {specialCallUsInstructions}
        </CaptionText>
      </div>
    );
  };

  return (
    <div className="sh_callUs_dialing_card">
      {renderInstructionalInfo()}
      {renderSpecialInstructions()}
    </div>
  );
}

Dialing.propTypes = {
  FPTIData: PropTypes.shape(FPTI_DATA).isRequired,
  callUsInfo: PropTypes.shape(CALL_US_INFO).isRequired,
  onWebPinClick: PropTypes.func.isRequired,
};

export default Dialing;
